import { Select } from "antd";
import React from "react";
// items 형식은 [{id , name }]
const CustomSelect = ({ items, value, label, key: selectKey, handleSet, width, disabled }) => {
    return (
        <Select
            value={value?.id}
            placeholder={label}
            style={{ width: width || 120 }}
            onChange={(val) => {
                const selected = items.find((item) => item.id === val);
                if (selected) handleSet(selectKey, selected);
            }}
            disabled={disabled}
            options={items.map((item) => ({ label: item.name, value: item.id }))}
            allowClear
        />
    );
};

export default CustomSelect;